module.exports = __webpack_public_path__ + "static/keyflow0-c7af60322604380552141680e5986a4c.mp4";